export var isXboxOne=function(){var e=navigator.userAgent.toLowerCase();return-1!==e.indexOf("xbox one")&&-1!==e.indexOf("edge")};